<template>
    <div class="w-full h-full relative">
        <div v-if="enabled" class="flex">
            <span v-if="isLoading"> Cargando...</span>
            <div v-else class="flex">
                <custom-multiple-select
                    v-model="options"
                    mode="search"
                    label="Almacenes actuales"
                    class="w-full min-w-full"
                    :options="selectOptions"
                    @change="onInput"
                />
            </div>
        </div>
        <div v-else class="flex flex-col h-full w-full min-w-full">
            <label class="block text-sm text-theme-muted mb-1">Comercios</label>

            <div class="flex flex-wrap px-2">
                <div
                    v-for="(item, index) in itemsCurrent"
                    :key="index"
                    class="bg-theme-disabled rounded-lg mx-1 mt-1"
                    :label="`${item.merchantType}:${item.merchantId}`"
                >
                    <div
                        class="bg-theme-primary rounded-lg px-1 capitalize py-1"
                    >
                        <span>
                            {{
                                item.merchantType | merchantInfo("icon", "type")
                            }}
                            {{ item.name }}
                        </span>
                    </div>
                    <div class="p-1">
                        <span>
                            {{ item.roleName }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import CustomMultipleSelect from "@/components/utils/CustomMultipleSelect.vue";

export default {
    name: "MerchantsRoleSelector",
    components: { CustomMultipleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        fill: {
            default: () => false,
            type: Boolean,
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["change"],
    data: () => ({
        options: [],
        isLoading: false,
        optionsBase: []
    }),
    computed: {
        ...mapState("commons", ["merchantsOwn"]),
        ...mapGetters("control", ["backgroundColor"]),
        selectOptions() {
            return this.optionsBase.map((item) => ({
                label: item.name,
                value: `${item.merchantType}:${item.merchantId}`
            }));
        }
    },
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    async mounted() {
        this.setInput(this.itemsCurrent);
        if (this.fill) {
            await this.reloadItems(false);
        }
    },
    methods: {
        ...mapActions("commons", ["listOwnMerchants"]),
        async reloadItems(required) {
            this.isLoading = true;
            try {
                const optionsBase = await this.listOwnMerchants({ required });
                this.optionsBase = [...optionsBase];
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        merchantObjectToString({ merchantId, merchantType }) {
            return `${merchantType}:${merchantId}`;
        },
        merchantStringToObject(merchantString) {
            const [merchantType, merchantId] = merchantString.split(":");
            return { merchantType, merchantId };
        },
        onInput(values) {
            const complete = this.optionsBase.filter((item) =>
                values.some((item2) => {
                    const { merchantId, merchantType } =
                        this.merchantStringToObject(item2);
                    return (
                        merchantId === item.merchantId &&
                        merchantType === item.merchantType
                    );
                })
            );
            this.$emit("change", complete);
        },
        setInput(values) {
            const aux = values.every((item) =>
                this.merchantsOwn.some(
                    (item2) =>
                        item2.merchantId === item.merchantId &&
                        item2.merchantType === item.merchantType
                )
            );
            if (!aux) {
                this.optionsBase = [...this.optionsBase, ...values].filter(
                    (value, index, self) =>
                        self.findIndex(
                            (item) =>
                                value.merchantId === item.merchantId &&
                                value.merchantType === item.merchantType
                        ) === index
                );
            }
            this.options = values.map(
                (item) => `${item.merchantType}:${item.merchantId}`
            );
        }
    }
};
</script>
